// extracted by mini-css-extract-plugin
export var active = "_9z-d";
export var blink = "_9z-e";
export var container = "_9z-5";
export var controls = "_9z-0";
export var controlsRight = "_9z-1";
export var fakeCursor = "_9z-c";
export var hidden = "_9z-b";
export var quillContainerSmall = "_9z-7";
export var quillEditor = "_9z-6";
export var quillEditorSmall = "_9z-8";
export var quillFormatButtons = "_9z-a";
export var quillToolbar = "_9z-9";
export var removePadding = "_9z-2";
export var state = "_9z-3";
export var stateTitle = "_9z-4";